import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { handlePostRequest } from '../service/PostTemplate';
import { endPoints } from '../Config';

const SupportHandoffButton = ({ complaintId, onTransferred, t = (value) => value }) => {
    const dispatch = useDispatch();
    const [visible, setVisible] = useState(false);
    const [reason, setReason] = useState('');
    const [saving, setSaving] = useState(false);
    const close = () => {
        if (saving) return;
        setVisible(false);
        setReason('');
    };
    const transfer = async () => {
        if (!complaintId || saving || reason.trim().length < 3) return;
        setSaving(true);
        try {
            const response = await dispatch(handlePostRequest(
                { reason: reason.trim() }, endPoints.sendComplaintToSupport(complaintId), true, true
            ));
            if (response?.status === 200) {
                setVisible(false);
                setReason('');
                await onTransferred?.();
            }
        } finally {
            setSaving(false);
        }
    };
    return (
        <>
            <Button label={t('Send to Customer Support')} icon="pi pi-arrow-right-arrow-left"
                className="p-button-outlined p-button-sm" onClick={() => setVisible(true)} />
            <Dialog header={t('Send to Customer Support')} visible={visible} modal
                style={{ width: 'min(95vw, 34rem)' }} onHide={close} closable={!saving}>
                <p>{t('Customer Support will take responsibility for the claim and review the refund. Open repair orders will leave the technical queue. Completed repairs will keep their technician, completion details and history.')}</p>
                <label htmlFor="support-handoff-reason" className="block mb-2">{t('Reason for transfer')}</label>
                <InputTextarea id="support-handoff-reason" value={reason} rows={4} maxLength={1000}
                    className="w-full" disabled={saving} onChange={(event) => setReason(event.target.value)} />
                <div className="flex justify-content-end gap-2 mt-3">
                    <Button label={t('Cancel')} className="p-button-text" onClick={close} disabled={saving} />
                    <Button label={t('Confirm transfer')} onClick={transfer} loading={saving}
                        disabled={saving || reason.trim().length < 3} />
                </div>
            </Dialog>
        </>
    );
};

export default SupportHandoffButton;
